export function isPast(type: string, id: string): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  const now = new Date()
  const old = Number(window.localStorage.getItem(`${type}_${id}_past`) || 0)
  if (!old) {
    return true
  }
  // 大于24小时
  return now.getTime() - old > 86400000
}

export function setPast(type: string, id: string): void {
  if (typeof window === 'undefined') {
    return
  }
  try {
    const now = new Date()
    window.localStorage.setItem(`${type}_${id}_past`, String(now.getTime()))
  } catch (err) {}
}
